import { TemperatureBandSummary } from "./TemperatureBandSummary";
import { EventBatchDetails } from "./EventBatchDetails";
import { BatchHistoryEntry } from "./BatchHistoryEntry";
import { ProductStorageType } from "./ProductStorageType";
import { DeviceDataSource } from "./DeviceDataSource";
import { BatchRangeImpact } from "./BatchRangeImpact";

export interface BatchImpactAssessment {
    batchId: number;
    batchNumber: string;
    productName: string;
    details: EventBatchDetails;
    highBandSummary: TemperatureBandSummary;
    lowBandSummary: TemperatureBandSummary;
    assessmentStatusId: AssessmentStatus;
    reviewerUserId: string;
    qaUserId: string;
    quantity: number;
    transportationUnitId: number;
    history: BatchHistoryEntry[];
    isReturnedToStock: boolean;
    productStorageType: ProductStorageType;
    dateQuarantined: Date;
    studyNumber: string;
    isPatientDosed: boolean;
    deviceDataSource: DeviceDataSource;
    batchRangesImpact: BatchRangeImpact[];
}

export enum AssessmentStatus {
    PendingReview,
    PendingDecision,
    EvaluationCompleted,
    ReAssessing,
}
